// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (function_: (...args: any[]) => any, ms = 300, maxWait = Infinity) => {
  let timeoutId: number;
  let maxWaitTimeoutId = 0;
  let savedArgs: any[];

  if (maxWait != Infinity && maxWait < ms) maxWait = ms + 1;

  return function (this: any, ...restArgs: any[]) {
    savedArgs = restArgs;
    if (maxWait != Infinity && maxWaitTimeoutId == 0) {
      maxWaitTimeoutId = window.setTimeout(() => {
        function_.apply(this, savedArgs);
        window.clearTimeout(timeoutId);
        maxWaitTimeoutId = 0;
      }, maxWait);
    }

    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      function_.apply(this, savedArgs);
      window.clearTimeout(maxWaitTimeoutId);
      maxWaitTimeoutId = 0;
    }, ms);
  };
};

export const genericDebounce = <T extends (...args: any[]) => any>(func: T, delay: number): T => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let lastResult: ReturnType<T>;

  const debouncedFunction = (...args: Parameters<T>): ReturnType<T> => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      lastResult = func(...args);
      timeoutId = null;
    }, delay);

    return lastResult!;
  };

  return debouncedFunction as T;
};
